import { useTranslation } from 'react-i18next';

import QuestionsPreview from '@/components/question/preview/QuestionsPreview';
import { Question } from '@/models/Question';

type QuestionPreviewProps = {
  question: Question;
};

export default function QuestionPreview({ question }: QuestionPreviewProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'questionsPreview',
  });

  return (
    <QuestionsPreview
      questions={[question]}
      title={t('questionTitle')}
      className="min-h-[300px] py-4 gap-6"
    />
  );
}
